<script lang="ts">
	import { onMount } from 'svelte';
	import { _ } from 'svelte-i18n';
	import { selectedClientStore } from '../../api/EnzianDataApi';
	import IconButton from '../../basic/buttons/IconButton.svelte';
	import { clickOutside, pressESC } from '../../helper/Extensions';
	import {
		clientStore,
		loadCleintsStore,
		showClientSwitcher,
		switchClientStore
	} from '../../stores/ClientStore';

	onMount(() => {
		loadCleintsStore();
	});
</script>

<div
	class="relative client"
	use:pressESC={() => {
		$showClientSwitcher = false;
	}}
	use:clickOutside={() => {
		$showClientSwitcher = false;
	}}
>
	<IconButton
		hoverText={$_('navigation.bt_switch_client')}
		text={$selectedClientStore != null ? $selectedClientStore.shortName : ''}
		onClick={() => ($showClientSwitcher = !$showClientSwitcher)}
	/>

	{#if $showClientSwitcher}
		<div
			style="top: 60px; left: -18px;"
			class="absolute p-4 bg-background dark:bg-dark-200 rounded-full left-0 z-50 grid gap-4 border-2 shadow-lg border-gray dark:border-dark-200"
		>
			{#each $clientStore as client}
				<IconButton
					primary={client.id === ($selectedClientStore ? $selectedClientStore.id : 0)}
					mainColor={'secondary'}
					text={client.shortName}
					hoverText={client.name}
					onClick={() => switchClientStore(client)}
				/>
			{/each}
		</div>
	{/if}
</div>
